import { useEffect, useState } from 'react';
import { Skiltformater } from '../utils/api';

export const useGyldigeSkiltformater = (
    gyldigeSkiltformaterRaw?: Skiltformater,
) => {
    const [gyldigeSkiltformater, setGyldigeSkiltformater] = useState<string[]>(
        [],
    );

    useEffect(() => {
        if (gyldigeSkiltformaterRaw) {
            setGyldigeSkiltformater(
                Array.from(
                    new Set(
                        gyldigeSkiltformaterRaw.bilBussLastebilTrekkbil?.ordinart?.flat(),
                    ),
                ),
            );
        }
    }, [gyldigeSkiltformaterRaw]);

    return gyldigeSkiltformater;
};
